import React, { useEffect, useState, useRef } from "react"
import Lib from 'library'
import { useLocation } from "react-router-dom"
import useApp from 'hooks/useApp'
import Native from 'library/native'
import { showSettingState, getNotiState, locationState, showAlertState } from "states/headerState"
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil"
import useAuth from "hooks/useAuth"

const SettingIcon = ({ className, noti = false }) => {

	const App = useApp()
	const Auth = useAuth()

	const setShowSetting = useSetRecoilState(showSettingState)

	const location = useLocation()
	const setLocation = useSetRecoilState(locationState)
	const [newNoti, setNewNoti] = useState(noti)
	const [data, setData] = useState()

	const [andAppVerNewIcon, setAndAppVerNewIcon] = useState()
	const [iosAppVerNewIcon, setIosAppVerNewIcon] = useState()
	const [ios, setIos] = useState()
	const [aos, setAos] = useState()
	const [version, setVersion] = useState(false)

	const mounted = useRef(false)

	useEffect(() => {
		if (Auth.isLogin) {
			console.log("Asdsadas");
			getNewIconData()
			getLatestVersion()
		}
	}, [location.pathname])

	const getNewIconData = () => {
		Lib.post(`/api/setting/main`, data => {
			if (!mounted.current) return
			setAndAppVerNewIcon(data.androidAppVer)
			setIosAppVerNewIcon(data.iosAppVer)

			if (data.anncmSno || data.inqrySno || data.eventSno || version) {
				setNewNoti(true)
			} else {
				setNewNoti(false)
			}
		})
	}

	useEffect(() => {
		if (!App.device) return
		let ver
		if (App.device.os?.toLowerCase() === "android") { //소문자변환
			ver = aos
			setVersion(andAppVerNewIcon === ver)
		} else {
			ver = ios
			setVersion(iosAppVerNewIcon === ver)
		}
	}, [ios, aos])

	//현재 설치된 앱버전 정보 가져오기
	const getLatestVersion = () => {
		Lib.get("/api/more/app/ver", data => {
			if (mounted.current) {
				setIos(data.iosAppVer)
				setAos(data.androidAppVer)
			}
		})
	}

	useEffect(() => {
		mounted.current = true
		return () => mounted.current = false
	}, [])

	// return <span onClick={() => setShowSetting(true)} className={`icon icon_setting${className ? ` ${className}` : ""}${newNoti === true ? " on" : ""}`} />
	return <div onClick={() => setShowSetting(true)} className={`icon-header-setting${className ? ` ${className}` : ""}${newNoti === true ? " on" : ""}`}><span className="btn-icon">설정</span></div>

}

const BellIcon = () => {
	const setShowAlert = useSetRecoilState(showAlertState)
	return (
		<React.Suspense fallback={<i onClick={() => alert("데이터 로딩중.")} />}>
			<Bell onClick={() => setShowAlert(true)} />
		</React.Suspense>
	)
}

const Bell = ({ className, noti = false, onClick }) => {
	const Auth = useAuth()

	const mounted = useRef()
	const location = useLocation()
	const [newItem, setNewItem] = useState(noti)
	const setLocation = useSetRecoilState(locationState)
	const [showAlert, setShowAlert] = useRecoilState(showAlertState)

	useEffect(() => {
		if (Auth.isLogin) {
			setLocation(location.pathname)
			getNoti()
		}

	}, [location.pathname])

	useEffect(() => {
		if (showAlert === false) {
			if (Auth.isLogin) {
				getNoti()
			}
		}
	}, [showAlert])

	//알림 데이터 api 호출
	const getNoti = () => {
		if (Auth.isLogin) {
			Lib.get(`/api/main/chk/new`, data => {
				if (data.nticCnt > 0) {
					mounted.current && setNewItem(true)
				} else {
					mounted.current && setNewItem(false)
				}
			})
		}
	}

	useEffect(() => {
		mounted.current = true
		return () => mounted.current = false
	}, [])

	return (
		<>
			{
				Auth.isLogin && ""
				// Auth.isLogin && (
				// 	<div onClick={onClick} className={`${className ? ` ${className}` : ""}${newItem === true ? " on" : ""}`}><span className="btn-icon">알림</span></div>
				// 	// <div onClick={onClick} className={`icon-header-noti${className ? ` ${className}` : ""}${newItem === true ? " on" : ""}`}><span className="btn-icon">알림</span></div>
				// 	// <span onClick={onClick} className={`icon icon_bell${className ? ` ${className}` : ""}${newItem === true ? " noti" : ""}`} />
				// )
			}
		</>
	)
}

const BackArrow = ({ className }) => {

	const App = useApp()

	return (
		<span className={`icon_arrow_back${className ? ` ${className}` : ""}`} onClick={() => {
			App.goBack()
			Native.vibrate()
		}} />
	)
}

export { SettingIcon, BellIcon, BackArrow }
